import { checkoutOptimizationStepArraySchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateProspectiveCheckoutTree = {
  name: "updateProspectiveCheckoutTree" as const,
  input: z.object({
    splitId: zExt.objectId(),
    checkoutTreeFlowSteps: checkoutOptimizationStepArraySchema,
  }),
  output: z.null(),
};
